import React, { useEffect, useState } from 'react'
import useMediaQuery from '../../hooks/useMediaQuery';
import CustomTable from '../../components/CustomTable/CustomTable';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import useTicket from '../../hooks/useTicket';
import { alertService } from '../../services/AlertService';
import UtilityService from '../../services/UtillityServices/UtilityService';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import { ACTION_TYPES } from '../../model/actions';
import useTicketConfigTable from '../../configTable/useTicketConfigTable';
import TicketManagerForm from '../../components/Forms/TicketManagerForm/TicketManagerForm';
import CustomModal from '../../components/CustomModal/CustomModal';
import { useNavigate } from 'react-router';

const GestioneTicketPage = () => {
  const {
    getTicketsByParams,
    loadingStateTicket,
    createTicket, 
    deleteTicket,
    modalStateTicket,
    setModalStateTicket,
  } = useTicket();

  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [formCreateTicket, setFormCreateTicket] = useState({});

  const [orderBy, setOrderBy] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1); 
  const [formDataFilter, setFormDataFilter] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingTickets, setIsLoadingTickets] = useState(false);
  const ticketConfigTable = useTicketConfigTable();


  useEffect(() => {
    if (!isLoadingTickets) {
      printAllTickets();
    }
  }, [orderBy, orderType, selectedPage]);
  
  const fetchTickets = async (obj) => {
    setIsLoadingTickets(true);
  
    obj = {
      ...obj,
      filtri: {
        ...obj.filtri,
      }
    };
  
    const fetchTicketList = await getTicketsByParams(obj);
    const countPagination = Math.ceil(fetchTicketList?.count / obj.limite);
    let ticketList = fetchTicketList?.data ?? [];
    setTotalPages(countPagination);
    setTickets(ticketList);
    setIsLoadingTickets(false);
    if(ticketList?.length === 0){
      setSelectedPage(1)
    }
  }
  
  const printAllTickets = async () => {
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: selectedPage ?? 1,
      ordinamento: `${orderBy ?? "data_modifica"} ${orderType ?? "desc"}`
    };
  
    await fetchTickets(obj);
  };
  
  const onFilteredTable = async () => {
    setSelectedPage(1);
  
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: 1,
      ordinamento: `${orderBy ?? "data_modifica"} ${orderType ?? "desc"}`
    };
  
    await fetchTickets(obj);
  };

  const openDeleteModal = (ticket) => {
    setSelectedTicket(ticket)
    setModalStateTicket(state => ({ ...state, showModalDeleteTicket: true }));
  }

  const handleCloseModal = () => {
    setModalStateTicket(state => ({ 
       ...state,
       showModalCreateTicket: false, 
       showModalInfoTicket: false, 
       showModalDeleteTicket: false,
       showModalUpdateTicket: false,
      }));
  }

  const openModalCreateTicket = () => {
    setModalStateTicket(state => ({ ...state, showModalCreateTicket: true }));
  }

  const renderSelectedDeleteTicket = () => {
    return (
      <>
      <span className="d-block fs-4 mb-2"><b>Vuoi eliminare il seguente ticket?</b> </span>
      <span className="d-block fs-5">{selectedTicket?.titolo}</span>
      </>
    )
  }

  const onCreateTicket = async () => {
    const requiredFields = ["oggetto", "descrizione"];
    const missingFields = UtilityService.validationForm(formCreateTicket, requiredFields);
    if (missingFields?.length > 0) {
        alertService.warn(`I seguenti campi sono obbligatori: ${missingFields}`, {autoClose: true});
        return;
    }

    formCreateTicket.id_corso = 142;
    const res = await createTicket(formCreateTicket);
    if(res) {
      printAllTickets();
    }

  };

  const onDeleteTicket = async () => {
    const obj = {id_ticket: selectedTicket?.id_ticket}
    const res = await deleteTicket(obj);
    if(res) {
      printAllTickets();
    }
  }

  const handleOrder = (orderBy, orderType) => {
    setOrderBy(orderBy);
    setOrderType(orderType);
  };

  const handlePageChange = (page) => {
    setSelectedPage(page);
  };

  const actions = [
    {
      label:  "Rispondi",
      icon: 'bi-pen text-dark',
      tooltip: "Rispondi",
      type: ACTION_TYPES.MANAGER,
      condition: () => true,
      onClick: (ticket) => navigate(`/ticket/${ticket.id_ticket}`)
    }
  ];

  return (
    <>
      <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`} style={{minHeight: '700px'}}>
        <div className='container'>
          <div className='d-flex justify-content-between custom-card-header'>
            <div className='d-flex gap-3 custom-card-title my-2'>
              <div className={`custom-icon-container`}>
                <i className={`bi custom-icon bi-ticket-detailed fs-2`}></i>
              </div>
              <div className='align-self-center'>
                <span className='fs-4 d-block'><i><b>Gestione ticket</b></i></span>
              </div>
            </div>
            <div className='align-self-center my-2'>
             {/*  <button type='button' className='btn btn-primary' onClick={openModalCreateTicket}>Crea ticket</button> */}
            </div>
          </div>
          <div className='mt-5'>
            <CustomFilterTable 
              formDataFilter={formDataFilter}
              setFormDataFilter={setFormDataFilter}
              onFilteredTable={onFilteredTable}
              isLoadingData={loadingStateTicket.isLoadingTicketsByParams}
              searchNodeType={[
                {nodeType: "input", name: "oggetto", placeholder: "Oggetto"},
                {nodeType: "select", name: "stato"}
              ]}
            />
          </div>
          {  !loadingStateTicket.isLoadingTicketsByParams ? ( 
              <>
         {(!tickets || tickets?.length === 0) ? (
                <div className='mt-5 pt-5 text-center'>
                    <p>Non ci sono ticket da mostrare.</p>
                </div>) : (
                  <>
                <CustomTable
                    data={tickets}
                    actions={actions}
                    columns={ticketConfigTable}
                    handleOrder={handleOrder}
                    orderBy={orderBy}
                    orderType={orderType}
                />
                <div className="d-flex justify-content-end mt-1">
                    <CustomPagination
                    totalPages={totalPages}
                    selectedPage={selectedPage}
                    handlePageChange={handlePageChange}
                    />
                </div>
                  </>

                )}
              </>
          ) : (
            <LoadingTable loadingCol={6} />
          ) }
          <>
          </>
        </div>
      </div>
      <CustomModal
        show={modalStateTicket.showModalCreateTicket}
        onHide={handleCloseModal}
        headerText="Crea ticket"
        size={"lg"}
        btnText={"Crea ticket"}
        body={<TicketManagerForm 
          formTicketManager={formCreateTicket}
          setFormTicketManager={setFormCreateTicket}
          showModalTicketManager={modalStateTicket.showModalCreateTicket}
        />} 
        isLoading={loadingStateTicket.isLoadingTicketCreating}
        closeButton={true}
        onUndoChanges={handleCloseModal}
        onSave={onCreateTicket} 
      />
{/*       <CustomModal
        show={modalStateTicket.showModalDeleteTicket}
        onHide={handleCloseModal}
        headerText="Elimina ticket"
        size={"md"}
        variant={"danger"}
        btnText={"Elimina"}
        body={renderSelectedDeleteTicket()} 
        isLoading={loadingStateTicket.isLoadingTicketDelete}
        closeButton={true}
        onUndoChanges={handleCloseModal}
        onSave={onDeleteTicket} 
      /> */}
    </>
  )
}

export default GestioneTicketPage;
